import axios from "axios";

const deleteClinicRoom = async (baseUrl, token, doctorId, clinicId, roomId) => {

    //doctor/{doctorid}/clinic/{clinicid}/room/{roomid}

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let deleteResponse = null

    await axios.delete(baseUrl + "/doctor/" + doctorId + "/clinic/" + clinicId + "/room/" + roomId, config)
        .then((res) => {
            deleteResponse = {
                status: res.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                deleteResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return deleteResponse
}

export default deleteClinicRoom;